<template>
	<div class="shareholder-overview shareholder-box">
		<h4 class="active-title">
			{{ $t('enterprise.shareholder')
			}}<span
				class="more position-abs"
				@click="goMore"
				v-if="stockholderInfo.date && stockholderInfo.date.length != 0"
				>{{ $t('enterprise.see-more') }}<i class="iconfont iconjiantouyou"></i
			></span>
		</h4>
		<div class="shareholder-echart" v-if="stockholderInfo.date && stockholderInfo.date.length != 0">
			<div class="more-shareholder">
				<div class="menu-module-right">
					{{ $t('enterprise.number-of-shareholders') }}（{{ $t('enterprise.thousand-households') }}）
				</div>
			</div>
			<BarEchartComponent :xData="stockholderInfo.date" :yBarData="stockholderInfo.stockholders" />
		</div>

		<div class="tab-bar__null" v-else>
			<CFullEmpty />
		</div>
	</div>
</template>

<script>
import BarEchartComponent from '@/view/enterprise/components/bar-echart-component.vue';
import CFullEmpty from '@/view/enterprise/components/c-full-empty.vue';
import { useNavigation } from '@rebuild/hooks/useNavigation';

export default {
	components: {
		BarEchartComponent,
		CFullEmpty
	},
	props: {
		stockholderInfo: {
			type: Object,
			default: () => ({})
		}
	},
	methods: {},
	setup() {
		const { goToModule } = useNavigation();
		const goMore = () => {
			goToModule('shareholder');
		};
		return {
			goMore
		};
	}
};
</script>

<style lang="less" scoped>
.shareholder-overview {
	padding-bottom: 0.16px;
	.active-title {
		position: relative;
		padding: 0.2rem 0 0.1rem 0;
		font-weight: 500;
		font-size: 0.15rem;
		line-height: 0.21rem;
		color: #333;
		.position-abs {
			right: 0;
			top: 0.21rem;
		}
	}

	.position-abs {
		position: absolute;
		top: 0.15rem;
		right: 0.12rem;
	}

	.more {
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: 0.11rem;
		line-height: 0.15rem;
		color: #666;
		.iconjiantouyou {
			font-size: 0.12rem;
		}
	}
}

.shareholder-box {
	padding-bottom: 0.16rem;
	margin-top: 0;
	border-radius: 0;
	.active-title {
		padding-bottom: 0;
	}

	.more-shareholder {
		display: flex;
		align-items: center;
		font-size: 12px;
		padding: 10px 0;
		&::before {
			content: '';
			width: 0.1rem;
			height: 0.1rem;
			border-radius: 0.02rem;
			background: var(--ir-theme-color);
			margin-right: 0.03rem;
		}
	}
	.tab-bar__null {
		height: 1.77rem;
	}
}
</style>
